module.exports = __webpack_public_path__ + "4595d7f8ce0e7b381abb0254f04f0ec2.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.ttf?v=1.1.0
// module id = 1020
// module chunks = 0